import { currencyFormatter } from 'utils'

export const GoalTableRow = ({ row }) => {
  return (
    <div className='table_row'>
      <label className='done yes'>
        <div className={row.isDone ? 'checked' : 'unchecked'}></div>
      </label>
      <label className='tier'>
        <span>{row.name}</span>
      </label>
      <label className='asset open profit'>{row.achievement}</label>
      <label className='reward'>{currencyFormatter(row.xp, { noCurrencySign: true, decimalDigits: 0 })} XP</label>
      <label className='difficulty'>{row.difficulty}</label>
    </div>
  )
}
